import { INDIA_PATHS, MAP_W, MAP_H, projectMap } from "./indiaMapData";

const CITY_COORDS = {
  "New Delhi": [77.2, 28.6],
  Jhajjar: [76.65, 28.6],
  "Kosi Kalan": [77.44, 27.79],
  Pali: [73.32, 25.77],
  Beawar: [74.32, 26.1],
  Ambala: [76.78, 30.38],
  Srinagar: [74.8, 34.08],
  Mumbai: [72.88, 19.08],
  Karwar: [74.13, 14.81],
  Mangalore: [74.86, 12.91],
  Durgapur: [87.32, 23.55],
  Guwahati: [91.74, 26.14],
  Surat: [72.83, 21.17],
  Vadodara: [73.19, 22.31],
};

const LABEL_PLACEMENT = {
  "New Delhi": { anchor: "end", dx: -20, dy: -10 },
  Jhajjar: { anchor: "end", dx: -12, dy: 24 },
  "Kosi Kalan": { anchor: "start", dx: 12, dy: 22 },
};

const MARKER_OFFSET = {
  Jhajjar: { dx: -9, dy: 8 },
};

function Marker({ loc }) {
  const coords = CITY_COORDS[loc.city];
  if (!coords) return null;
  let [x, y] = projectMap(coords[0], coords[1]);
  const offset = MARKER_OFFSET[loc.city];
  if (offset) {
    x += offset.dx;
    y += offset.dy;
  }
  const isHQ = loc.type === "hq";
  const isPlant = loc.type === "plant";
  const core = isHQ ? 7 : isPlant ? 6 : 3.5;
  const color = isHQ || isPlant ? "#FF5722" : "#d4d4d4";
  const lp = LABEL_PLACEMENT[loc.city] || { anchor: "start", dx: core + 6, dy: 4 };
  return (
    <g data-testid={`map-marker-${loc.id}`}>
      <title>{`${loc.city}${loc.state ? `, ${loc.state}` : ""}${loc.detail ? ` — ${loc.detail}` : ""}`}</title>
      <circle cx={x} cy={y} r={core * 1.4} fill="none" stroke={color} strokeWidth="1.5" opacity="0.7">
        <animate attributeName="r" values={`${core * 1.4};${core * 4}`} dur="2.4s" repeatCount="indefinite" />
        <animate attributeName="opacity" values="0.7;0" dur="2.4s" repeatCount="indefinite" />
      </circle>
      {isHQ ? (
        <rect
          x={x - core}
          y={y - core}
          width={core * 2}
          height={core * 2}
          fill={color}
          transform={`rotate(45 ${x} ${y})`}
          style={{ filter: "drop-shadow(0 0 8px rgba(255,87,34,0.9))" }}
        />
      ) : (
        <circle cx={x} cy={y} r={core} fill={color} style={{ filter: isPlant ? "drop-shadow(0 0 8px rgba(255,87,34,0.9))" : "drop-shadow(0 0 5px rgba(255,255,255,0.5))" }} />
      )}
      {(isHQ || isPlant) && (
        <text
          x={x + lp.dx}
          y={y + lp.dy}
          textAnchor={lp.anchor}
          fill={isHQ ? "#FF8A65" : "#e5e5e5"}
          fontSize="13"
          className="hidden sm:inline"
          fontFamily="'JetBrains Mono', monospace"
          letterSpacing="1"
        >
          {loc.city.toUpperCase()}
        </text>
      )}
    </g>
  );
}

export default function IndiaMap({ locations }) {
  const mapped = locations.filter((l) => CITY_COORDS[l.city]);
  return (
    <svg viewBox={`0 0 ${MAP_W} ${MAP_H}`} className="h-auto w-full" data-testid="india-map" role="img" aria-label="Catalyst Petrochem footprint map of India">
      <defs>
        <radialGradient id="mapGlow" cx="45%" cy="35%" r="75%">
          <stop offset="0%" stopColor="#181818" />
          <stop offset="100%" stopColor="#0A0A0A" />
        </radialGradient>
      </defs>
      <g>
        {INDIA_PATHS.map((d, i) => (
          <path key={i} d={d} fill="url(#mapGlow)" stroke="rgba(255,255,255,0.1)" strokeWidth="1" />
        ))}
      </g>
      {mapped.map((loc) => (
        <Marker key={loc.id} loc={loc} />
      ))}
    </svg>
  );
}
